module.exports = __webpack_public_path__ + "img/reserved_electric.37bf8306.svg";